import { useTranslation } from "react-i18next";

import { Box, Stack, Typography } from "@mui/material";

const INFO = "clients.client.debtSettlement.assetInventory.donationsTab.assetSettlement.info";

const ASSET_KEYS = ["cash", "securities", "valuables", "companies", "realEstate", "cooperative"] as const;
const EXAMPLE_KEYS = [
  "divorce",
  "sharedProperty",
  "waiver",
  "residenceRight",
  "mortgages",
  "pledges",
  "assignment",
] as const;

export function AssetSettlementInfo() {
  const { t } = useTranslation();

  return (
    <Stack gap={1}>
      <Typography variant="body2">{t(`${INFO}.intro`)}</Typography>
      <Typography variant="body2" component="h3" sx={{ fontWeight: 600 }}>
        {t(`${INFO}.assetsTitle`)}
      </Typography>
      <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
        {ASSET_KEYS.map((key) => (
          <Typography key={key} variant="body2" component="li">
            {t(`${INFO}.assets.${key}`)}
          </Typography>
        ))}
      </Box>
      <Typography variant="body2" component="h3" sx={{ fontWeight: 600 }}>
        {t(`${INFO}.examplesTitle`)}
      </Typography>
      <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
        {EXAMPLE_KEYS.map((key) => (
          <Typography key={key} variant="body2" component="li">
            {t(`${INFO}.examples.${key}`)}
          </Typography>
        ))}
      </Box>
    </Stack>
  );
}
